import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import TableComponent from 'UiKit/table-component';
import { Condition } from 'Component/others';
import useGetRulesetList from 'Domain/schedule-ruleset/useGetRulesetList';

import { useScheduleRulesetState } from 'View/schedule-ruleset/state';
import { TableSkeleton } from 'View/schedule-ruleset/components/skeleton/index';

import buildTableList from './const';
import styles from './styles.module.css';

const Table = () => {
  const { t } = useTranslation('schedule-ruleset');
  const { updateFilterState, filterState } = useScheduleRulesetState();
  const { data: dataRuleSet, isFetching } = useGetRulesetList(filterState);
  const tableList = buildTableList(t);

  const onChangePagination = (page) => updateFilterState({ page });
  const onSort = (sort) => updateFilterState({ sort });

  return (
    <Condition statement={!isFetching} fallback={<TableSkeleton />}>
      <Box className={styles['table__container']}>
        <Box className={styles['table__wrapper']} data-testid="table__schedule-ruleset">
          <TableComponent
            tableName="table__schedule-ruleset"
            columns={tableList}
            dataSource={dataRuleSet?.scheduleRulesets}
            isDataExist={dataRuleSet?.isDataExist}
            onSort={onSort}
            sortingData={filterState?.sort}
            maxTableHeight="calc(100vh - 287px)"
            maxTableBodyHeight="calc(100vh - 402px)"
            tableComponentHeight="calc(100vh - 233px)"
            pagination={{
              currentPage: filterState?.page,
              totalData: dataRuleSet?.totalData,
              onChange: onChangePagination,
              isLoading: isFetching,
            }}
          />
        </Box>
      </Box>
    </Condition>
  );
};

export default Table;
